<template>
<div class="main-panel">
    <top-navbar></top-navbar>
    <div class="content">
        <div class="card">
            <FlashMessage :position="'right top'"></FlashMessage>

            <div class="card-header">
                <h4 class="title">Edit User</h4>
            </div>
            <div class="card-body">
                <form @submit.prevent="update">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Name<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.name.$model" type="text" label="Name" placeholder="Enter name" />
                            <div class="error" v-if="submitted && !$v.userdata.name.required">Please enter name</div>
                        </div>

                        <div class="col-md-4">
                            <label>Email<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.email.$model" type="text" label="Email" placeholder="Enter email" />
                            <div class="error" v-if="submitted && !$v.userdata.email.required">Please enter email</div>
                            <div class="error" v-if="submitted && !$v.userdata.email.email">Please enter valid email</div>

                        </div>
                        <div class="col-md-4">
                            <label>Mobile Number<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.number.$model" type="text" label="Number" placeholder="Enter mobile number" @keypress="onlyNumber" maxlength="10" />
                            <div class="error" v-if="submitted && !$v.userdata.number.required">Please enter mobile number</div>
                            <div class="error" v-if="submitted && !$v.userdata.number.minLength">Please enter valid mobile number</div>
                            <div class="error" v-if="submitted && !$v.userdata.number.maxLength">Please enter valid mobile number</div>
                        </div>
                    </div>
                    <br />
                    <div class="row">
                        <div class="col-md-4">
                            <label>Role<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.userdata.role.$model">
                                <option disabled value>Select role</option>
                                <option v-for="(roles, index) in role" :value="roles.roleid" :key="index">
                                    {{ roles.role }}
                                </option>
                            </select>
                            <div class="error" v-if="submitted && !$v.userdata.role.required">Please select role</div>

                        </div>

                        <div class="col-md-4">
                            <label>Status<em style="color:red">*</em></label>
                            <select class="form-control" v-model.trim="$v.userdata.status.$model">
                                <option disabled>Select status</option>
                                <option value="1">Active</option>
                                <option value="0">InActive</option>
                                <option value="2">Block</option>
                            </select>
                            <div class="error" v-if="submitted && !$v.userdata.status.required">Please select status</div>

                        </div>

                        <!-- <div class="col-md-4">
                            <label>Password<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.password.$model" type="password" label="Password" placeholder="Enter password" />
                            <div class="error" v-if="submitted && !$v.userdata.password.required">Please enter password</div>
                        </div>

                        <div class="col-md-4">
                            <label>Confirm Password<em style="color:red">*</em></label>
                            <input class="form-control" v-model.trim="$v.userdata.password_confirmation.$model" type="text" label="Confirm Password" placeholder="Enter confirm password" />
                            <div class="error" v-if="submitted && !$v.userdata.password_confirmation.required">Please enter confirm password</div>
                            <div class="error" v-if="submitted && $v.userdata.password_confirmation.required && $v.userdata.password.required && !$v.userdata.password_confirmation.sameAsPassword">Password don't match</div>
                        </div> -->
                    </div>
                    <br />
                    <div class="text">
                        <button type="submit" class="btn btn-secondary dashboard">Update</button>&nbsp;
                        <router-link to="/admin/dashboard/user"><button type="button" class="btn btn-secondary dashboard">Cancel</button></router-link>
                    </div>

                </form>
            </div>
        </div>

    </div>
    <content-footer></content-footer>
</div>
</template>

<script>
import TopNavbar from "../../Dashboard/Layout/TopNavbar.vue";
import ContentFooter from "../../Dashboard/Layout/ContentFooter.vue";
import ValidationError from "src/components/UIComponents/ValidationError.vue";
import {
    required,
    minLength,
    maxLength,
    between,
    sameAs,
    email,
} from "vuelidate/lib/validators";
export default {
    name: 'editUser',
    components: {
        TopNavbar,
        ContentFooter,
        ValidationError,
    },

    data() {
        return {
            submitted: false,
            role: [],
            userdata: {
                name: '',
                email: '',
                number: '',
                role: '',
                status: '',
                // password: '',
                // password_confirmation: '',
            }
        }
    },

    validations: {
        userdata: {
            name: {
                required,
            },
            email: {
                required,
                email,
            },
            role: {
                required,
            },
            number: {
                required,
                minLength: minLength(10),
                maxLength: maxLength(10),
            },
            status: {
                required,
            },
            // password: {
            //     required,
            // },
            // password_confirmation: {
            //     required,
            //     sameAsPassword: sameAs('password'),
            // },
        }
    },

    methods: {

        onlyNumber($event) {
            //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault();
            }
        },

        update() {
            this.submitted = true;
            this.$v.$touch()
            if (this.$v.$invalid) {
                return;
            } else {

                this.axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/user/update/` + this.$route.params.id, this.userdata)
                    .then(({
                        data
                    }) => {
                        this.$router.push('/admin/dashboard/user');
                        this.flashMessage.success({
                            message: 'User Updated Successfully',
                        });
                    })
                    .catch((error) => {
                        if (error.response.data.errors.number) {
                            this.flashMessage.error({
                                message: 'The number has already been taken',
                            });
                        }
                        if (error.response.data.errors.email) {
                            this.flashMessage.error({
                                message: 'The email has already been taken',
                            });
                        }
                    });
            }
        }
    },

    async mounted() {
        await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/getactiverole`).then((res) => {
            this.role = res.data;
        });

        const userdata = await this.axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/admin/dashboard/user/edit/` + this.$route.params.id);
        this.userdata = userdata.data.data;
    },

};
</script>

<style lang="scss">
</style>
